import { action, fsa } from "ts-action";
import { TemplateNotification } from "../../../globalTypes";

export const receiveTemplateNotification = action(
  "NOTIFICATIONS : TEMPLATE > GET MESSAGES > RECEIVE (signalR)",
  fsa<{ notification: TemplateNotification }>()
);

export const requestTemplateNotifications = action(
  "NOTIFICATIONS : TEMPLATE > GET MESSAGES > REQUEST"
);

export const receiveTemplateNotifications = action(
  "NOTIFICATIONS : TEMPLATE > GET MESSAGES > RECEIVE (signalR)", // aby bylo v devtools jasnější, že se to může dispatchnout i bez requestu
  fsa<{ notifications: TemplateNotification[] }>()
);

export const errorRequestTemplateNotifications = action(
  "NOTIFICATIONS : TEMPLATE > GET MESSAGES > ERROR"
);
